export const getVideoData = (link?: string) => {
  if (!link) return { videoType: '', videoId: '', videoControls: [] };

  const videoType = link.includes('youtu')
    ? 'youtube'
    : link.includes('vimeo')
    ? 'vimeo'
    : '';

  const parts = link.split('/');
  const videoId = parts[parts.length - 1];

  const videoControls = [
    'play-large',
    'play',
    'fullscreen',
    'mute',
    'progress',
  ];

  return { videoType, videoId, videoControls };
};
